import config from 'constants/config'

/**
 * Whether Agent Hub can apply Société to a booking via the traveller member
 * number, so the customer earns points on the sale.
 *
 * This is not the same as `LUX_LOYALTY_IN_AGENT_HUB`, which is for the agent
 * earning points on their own account.
 *
 * Kept out of agentHubSelectors so loyalty selectors can use it without
 * pulling commissionMap via agentHubSelectors.
 */
export const isLuxLoyaltyEnabledInAgentHub = config.agentHub.isEnabled && config.LUX_LOYALTY_ENABLED
